import React from 'react';

type LoginBoxProps = { children: React.ReactNode };

const LoginBox = ({ children }: LoginBoxProps) => {
	// a aspa depois de absolute é da propria vtex
	return (
		<div
			className={`vtex-login-2-x-box box z-max absolute"`}
			style={{
				right: '-50px',
				width: 'max-content',
				maxWidth: '340px',
			}}
		>
			{children}
		</div>
	);
};

export default LoginBox;
